import React, { Fragment } from 'react';
import { GOOGLE_MAPS_LINK } from 'constant/settings';
import { styWrapper } from './styles';

function LocationSection() {
  return (
    <Fragment>
      <div id="fh5co-couple-story" className="fh5co-section-gray" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
              <h2 className="main-font">Lokasi Acara</h2>
              <p className="sub-title">
                <a
                  href={GOOGLE_MAPS_LINK}
                  title="Click untuk melihat peta di Google Maps"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#828282' }}
                >
                  <strong>Kediaman calon mempelai wanita, Sukabumi</strong>
                </a>{' '}
                <br />
                Gg. Berdikari 1, Nyomplong, Kec. Warudoyong, <br />
                Kota Sukabumi, Jawa Barat 50136
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d495.0895217029109!2d106.91998006441801!3d-6.924492021820034!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e684825eaa0bbb7%3A0x49f6db74de836ba4!2sGg.%20Berdikari%20I%2C%20Benteng%2C%20Kec.%20Warudoyong%2C%20Kota%20Sukabumi%2C%20Jawa%20Barat%2043131!5e0!3m2!1sen!2sid!4v1638420879415!5m2!1sen!2sid"
                width="100%"
                height="450"
                frameBorder="0"
                style={{ border: '0' }}
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
                title="Google Maps - Shania & Torik Wedding Party"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default React.memo(LocationSection);
